import { Video } from "@hl/base-components/lib/video";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import { Box, Center, useMantineTheme } from "@mantine/core";

export const CollectionMedia = ({
  imageUrl,
  animationUrl,
  height,
  width,
}: {
  imageUrl?: string | null;
  animationUrl?: string | null;
  height: string;
  width: string;
}) => {
  const theme = useMantineTheme();

  if (imageUrl) {
    return (
      <Center>
        <ResizedImage
          // sx={{
          //   TODO: figure this out later
          //   border: `0.5px solid ${theme.colors.divider[0]}`,
          // }}
          src={imageUrl}
          fit="contain"
          height={height}
          // width={width}
        />
      </Center>
    );
  }

  if (animationUrl) {
    return (
      <Center w="100%">
        <Video
          style={{
            objectFit: "contain",
            height,
            zIndex: 0,
            width,
            border: `0.5px solid ${theme.colors.divider[0]}`,
          }}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={animationUrl} />
        </Video>
      </Center>
    );
  }

  //Placeholder
  return (
    <Box
      sx={{
        border: `0.5px solid ${theme.colors.divider[0]}`,
      }}
      h={height}
      w="100%"
    />
  );
};
